// extracted by mini-css-extract-plugin
export default {"container":"PopularSpots_container__76wEp","card-container":"PopularSpots_card-container__WMnQc","right-arrow":"PopularSpots_right-arrow__hZPBO"};